"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "capo-di-ponte": {
    "12339c53": [{
      "hkey": "fe1c056b",
      "slug": "capo-di-ponte",
      "name": "Capo di Ponte",
      "primary": true,
      "skipSearch": false
    }],
    "cemmo": [{
      "hkey": "fe1c056b",
      "slug": "capo-di-ponte",
      "name": "Capo di Ponte",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;